import { Record, Union } from "./fable_modules/fable-library.3.7.12/Types.js";
import { unit_type, lambda_type, class_type, list_type, tuple_type, record_type, int32_type, option_type, bool_type, string_type, union_type } from "./fable_modules/fable-library.3.7.12/Reflection.js";
import { Project$reflection, Product$reflection, SalesList$reflection, SparePart$reflection, ProjectId$reflection, ProductId$reflection, SalesListId$reflection, SparePartId$reflection } from "../SparePartInfo/CommonTypes.fs.js";
import { ListLoadStep } from "./Constants.fs.js";
import { empty } from "./fable_modules/fable-library.3.7.12/List.js";
import { ofNullable } from "../../Fame/Core/String.fs.js";
import { Translation$reflection } from "./Localization.fs.js";
import { Locale$reflection } from "../../Fame/Localization/Locale.fs.js";

export class CentralLocal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Central", "Local"];
    }
}

export function CentralLocal$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.CentralLocal", [], CentralLocal, () => [[], []]);
}

export function CentralLocalModule_toString(_arg1) {
    if (_arg1.tag === 1) {
        return "L";
    }
    else {
        return "C";
    }
}

export function CentralLocalModule_tryParse(_arg1) {
    switch (_arg1) {
        case "C": {
            return new CentralLocal(0);
        }
        case "L": {
            return new CentralLocal(1);
        }
        default: {
            return void 0;
        }
    }
}

export class LookupFilter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FromSparePart", "FromSalesList", "FromProduct", "FromProject"];
    }
}

export function LookupFilter$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.LookupFilter", [], LookupFilter, () => [[["Item", SparePartId$reflection()]], [["Item", SalesListId$reflection()]], [["Item", ProductId$reflection()]], [["Item", ProjectId$reflection()]]]);
}

export class SparePartFilter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["MaterialNo", "Division", "Hierarchy", "Engineer", "Planner", "CriticalPart", "EndOfLife", "CentralLocal"];
    }
}

export function SparePartFilter$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.SparePartFilter", [], SparePartFilter, () => [[["Item", SparePartId$reflection()]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", option_type(bool_type)]], [["Item", bool_type]], [["Item", CentralLocal$reflection()]]]);
}

export class ProductFilter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Hierarchy", "ProductGroupPlant", "Engineer", "EndOfLife", "CentralLocal"];
    }
}

export function ProductFilter$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.ProductFilter", [], ProductFilter, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", CentralLocal$reflection()]]]);
}

export class ProjectFilter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Hierarchy", "ProductGroupPlant", "Engineer", "EndOfLife"];
    }
}

export function ProjectFilter$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.ProjectFilter", [], ProjectFilter, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]]]);
}

export class Page extends Record {
    constructor(SparePartPage, SalesListPage, ProductPage, ProjectPage) {
        super();
        this.SparePartPage = (SparePartPage | 0);
        this.SalesListPage = (SalesListPage | 0);
        this.ProductPage = (ProductPage | 0);
        this.ProjectPage = (ProjectPage | 0);
    }
}

export function Page$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.Page", [], Page, () => [["SparePartPage", int32_type], ["SalesListPage", int32_type], ["ProductPage", int32_type], ["ProjectPage", int32_type]]);
}

export class OrderDirection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Ascending", "Descending"];
    }
}

export function OrderDirection$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.OrderDirection", [], OrderDirection, () => [[], []]);
}

export function OrderDirectionModule_tryParse(_arg1) {
    switch (_arg1) {
        case "asc": {
            return new OrderDirection(0);
        }
        case "desc": {
            return new OrderDirection(1);
        }
        default: {
            return void 0;
        }
    }
}

export function OrderDirectionModule_toString(_arg1) {
    if (_arg1.tag === 1) {
        return "desc";
    }
    else {
        return "asc";
    }
}

export class OrderField extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SparePartField", "SalesListField", "ProductField", "ProjectField"];
    }
}

export function OrderField$reflection() {
    return union_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.OrderField", [], OrderField, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class Order extends Record {
    constructor(SparePartOrder, SalesListOrder, ProductOrder, ProjectOrder) {
        super();
        this.SparePartOrder = SparePartOrder;
        this.SalesListOrder = SalesListOrder;
        this.ProductOrder = ProductOrder;
        this.ProjectOrder = ProjectOrder;
    }
}

export function Order$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.Order", [], Order, () => [["SparePartOrder", option_type(tuple_type(string_type, OrderDirection$reflection()))], ["SalesListOrder", option_type(tuple_type(string_type, OrderDirection$reflection()))], ["ProductOrder", option_type(tuple_type(string_type, OrderDirection$reflection()))], ["ProjectOrder", option_type(tuple_type(string_type, OrderDirection$reflection()))]]);
}

export const OrderModule_empty = new Order(void 0, void 0, void 0, void 0);

export class SearchFilter extends Record {
    constructor(Query, Lookup, Page, Order, PageSize, SparePartFilter, ProductFilter, ProjectFilter) {
        super();
        this.Query = Query;
        this.Lookup = Lookup;
        this.Page = Page;
        this.Order = Order;
        this.PageSize = (PageSize | 0);
        this.SparePartFilter = SparePartFilter;
        this.ProductFilter = ProductFilter;
        this.ProjectFilter = ProjectFilter;
    }
}

export function SearchFilter$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.SearchFilter", [], SearchFilter, () => [["Query", option_type(string_type)], ["Lookup", option_type(LookupFilter$reflection())], ["Page", Page$reflection()], ["Order", Order$reflection()], ["PageSize", int32_type], ["SparePartFilter", list_type(SparePartFilter$reflection())], ["ProductFilter", list_type(ProductFilter$reflection())], ["ProjectFilter", list_type(ProjectFilter$reflection())]]);
}

export const SearchFilterModule_empty = new SearchFilter(void 0, void 0, new Page(1, 1, 1, 1), OrderModule_empty, ListLoadStep, empty(), empty(), empty());

export function SearchFilterModule_withQuery(query) {
    return new SearchFilter(ofNullable(query), SearchFilterModule_empty.Lookup, SearchFilterModule_empty.Page, SearchFilterModule_empty.Order, SearchFilterModule_empty.PageSize, SearchFilterModule_empty.SparePartFilter, SearchFilterModule_empty.ProductFilter, SearchFilterModule_empty.ProjectFilter);
}

export function SearchFilterModule_withOrder(searchFilter, field, direction) {
    const currentOrder = searchFilter.Order;
    return new SearchFilter(searchFilter.Query, searchFilter.Lookup, searchFilter.Page, (field.tag === 1) ? (new Order(currentOrder.SparePartOrder, [field.fields[0], direction], currentOrder.ProductOrder, currentOrder.ProjectOrder)) : ((field.tag === 2) ? (new Order(currentOrder.SparePartOrder, currentOrder.SalesListOrder, [field.fields[0], direction], currentOrder.ProjectOrder)) : ((field.tag === 3) ? (new Order(currentOrder.SparePartOrder, currentOrder.SalesListOrder, currentOrder.ProductOrder, [field.fields[0], direction])) : (new Order([field.fields[0], direction], currentOrder.SalesListOrder, currentOrder.ProductOrder, currentOrder.ProjectOrder)))), searchFilter.PageSize, searchFilter.SparePartFilter, searchFilter.ProductFilter, searchFilter.ProjectFilter);
}

export class ResultCounts extends Record {
    constructor(Products, Projects, SpareParts, SalesLists) {
        super();
        this.Products = (Products | 0);
        this.Projects = (Projects | 0);
        this.SpareParts = (SpareParts | 0);
        this.SalesLists = (SalesLists | 0);
    }
}

export function ResultCounts$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.ResultCounts", [], ResultCounts, () => [["Products", int32_type], ["Projects", int32_type], ["SpareParts", int32_type], ["SalesLists", int32_type]]);
}

export class SparePartSearchResult extends Record {
    constructor(SpareParts, FilteredCount, Divisions, Hierarchies, Planner, Engineer) {
        super();
        this.SpareParts = SpareParts;
        this.FilteredCount = (FilteredCount | 0);
        this.Divisions = Divisions;
        this.Hierarchies = Hierarchies;
        this.Planner = Planner;
        this.Engineer = Engineer;
    }
}

export function SparePartSearchResult$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.SparePartSearchResult", [], SparePartSearchResult, () => [["SpareParts", list_type(SparePart$reflection())], ["FilteredCount", int32_type], ["Divisions", list_type(tuple_type(string_type, int32_type))], ["Hierarchies", list_type(tuple_type(string_type, int32_type))], ["Planner", list_type(tuple_type(string_type, int32_type))], ["Engineer", list_type(tuple_type(string_type, int32_type))]]);
}

export class SalesListSearchResult extends Record {
    constructor(SalesLists, FilteredCount) {
        super();
        this.SalesLists = SalesLists;
        this.FilteredCount = (FilteredCount | 0);
    }
}

export function SalesListSearchResult$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.SalesListSearchResult", [], SalesListSearchResult, () => [["SalesLists", list_type(SalesList$reflection())], ["FilteredCount", int32_type]]);
}

export class ProductSearchResult extends Record {
    constructor(Products, FilteredCount, Hierarchies, Engineer, ProductGroupPlants) {
        super();
        this.Products = Products;
        this.FilteredCount = (FilteredCount | 0);
        this.Hierarchies = Hierarchies;
        this.Engineer = Engineer;
        this.ProductGroupPlants = ProductGroupPlants;
    }
}

export function ProductSearchResult$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.ProductSearchResult", [], ProductSearchResult, () => [["Products", list_type(Product$reflection())], ["FilteredCount", int32_type], ["Hierarchies", list_type(tuple_type(string_type, int32_type))], ["Engineer", list_type(tuple_type(string_type, int32_type))], ["ProductGroupPlants", list_type(tuple_type(string_type, int32_type))]]);
}

export class ProjectSearchResult extends Record {
    constructor(Projects, FilteredCount, Hierarchies, Engineer, ProductGroupPlants) {
        super();
        this.Projects = Projects;
        this.FilteredCount = (FilteredCount | 0);
        this.Hierarchies = Hierarchies;
        this.Engineer = Engineer;
        this.ProductGroupPlants = ProductGroupPlants;
    }
}

export function ProjectSearchResult$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.ProjectSearchResult", [], ProjectSearchResult, () => [["Projects", list_type(Project$reflection())], ["FilteredCount", int32_type], ["Hierarchies", list_type(tuple_type(string_type, int32_type))], ["Engineer", list_type(tuple_type(string_type, int32_type))], ["ProductGroupPlants", list_type(tuple_type(string_type, int32_type))]]);
}

export class Document$ extends Record {
    constructor(Name, ContentType, Url) {
        super();
        this.Name = Name;
        this.ContentType = ContentType;
        this.Url = Url;
    }
}

export function Document$$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.Document", [], Document$, () => [["Name", string_type], ["ContentType", string_type], ["Url", string_type]]);
}

export class Context extends Record {
    constructor(PublishDate, IsInternal, SearchSpareParts, SearchSalesLists, SearchProducts, SearchProjects, GetSparePartDocuments, GetCounts, ExportXLSX, GetSparePart, GetSalesList, GetProduct, GetProject, GetProductHierarchies, GetProductGroupPlants, GetDivisions, GetSerialNoHints) {
        super();
        this.PublishDate = PublishDate;
        this.IsInternal = IsInternal;
        this.SearchSpareParts = SearchSpareParts;
        this.SearchSalesLists = SearchSalesLists;
        this.SearchProducts = SearchProducts;
        this.SearchProjects = SearchProjects;
        this.GetSparePartDocuments = GetSparePartDocuments;
        this.GetCounts = GetCounts;
        this.ExportXLSX = ExportXLSX;
        this.GetSparePart = GetSparePart;
        this.GetSalesList = GetSalesList;
        this.GetProduct = GetProduct;
        this.GetProject = GetProject;
        this.GetProductHierarchies = GetProductHierarchies;
        this.GetProductGroupPlants = GetProductGroupPlants;
        this.GetDivisions = GetDivisions;
        this.GetSerialNoHints = GetSerialNoHints;
    }
}

export function Context$reflection() {
    return record_type("Fame.Fts.Toolbox.SparePartInfo.UI.Context.Context", [], Context, () => [["PublishDate", class_type("System.DateTimeOffset")], ["IsInternal", bool_type], ["SearchSpareParts", lambda_type(SearchFilter$reflection(), tuple_type(ResultCounts$reflection(), SparePartSearchResult$reflection()))], ["SearchSalesLists", lambda_type(SearchFilter$reflection(), tuple_type(ResultCounts$reflection(), SalesListSearchResult$reflection()))], ["SearchProducts", lambda_type(SearchFilter$reflection(), tuple_type(ResultCounts$reflection(), ProductSearchResult$reflection()))], ["SearchProjects", lambda_type(SearchFilter$reflection(), tuple_type(ResultCounts$reflection(), ProjectSearchResult$reflection()))], ["GetSparePartDocuments", lambda_type(SparePartId$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [class_type("System.Collections.Generic.IEnumerable`1", [Document$$reflection()])]))], ["GetCounts", lambda_type(SearchFilter$reflection(), ResultCounts$reflection())], ["ExportXLSX", lambda_type(Translation$reflection(), lambda_type(SearchFilter$reflection(), unit_type))], ["GetSparePart", lambda_type(SparePartId$reflection(), option_type(SparePart$reflection()))], ["GetSalesList", lambda_type(SalesListId$reflection(), option_type(SalesList$reflection()))], ["GetProduct", lambda_type(ProductId$reflection(), option_type(Product$reflection()))], ["GetProject", lambda_type(ProjectId$reflection(), option_type(Project$reflection()))], ["GetProductHierarchies", lambda_type(unit_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]))], ["GetProductGroupPlants", lambda_type(unit_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]))], ["GetDivisions", lambda_type(unit_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Locale$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]))], ["GetSerialNoHints", lambda_type(unit_type, class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type]))]]);
}

